import { Component } from '@angular/core';
import { ModalComponent } from '@components/common/modal/modal.component';

@Component({
  selector: 'ark-lib-think-tank-proposition-dialog',
  templateUrl: './think-tank-proposition-dialog.component.html',
  styleUrl: './think-tank-proposition-dialog.component.css',
})
export class ThinkTankPropositionDialogComponent {
  constructor(protected readonly parent: ModalComponent) {}
  close() {
    this.parent.close();
  }
}
